class NpThumSwiper extends HTMLElement {
  constructor() {
    super();
    NpThumSwiper.scrollSlider();
    NpThumSwiper.thumbSlider();
    NpThumSwiper.activeSlide(this.dataset.src);
    // NpThumSwiper.scrollSwiper.controller.control = NpThumSwiper.thumbSwiper;
    // NpThumSwiper.thumbSwiper.controller.control = NpThumSwiper.scrollSwiper;
  }
  static thumbSlider() {
    NpThumSwiper.thumbSwiper = new Swiper(".mpThumbSwiepr", {
      // autoHeight: true,
      pagination: {
        el: ".np-ts-pagimation",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 2,
      },
      navigation: {
        nextEl: ".np-thumb-next",
        prevEl: ".np-thumb-prev",
        disabledClass: "swiper-button-disabled",
      },
      spaceBetween: 10,
      thumbs: {
        swiper: NpThumSwiper.scrollSwiper,
      },
      breakpoints: {
        300: {
          spaceBetween: 0,
        },
        769: {
          spaceBetween: 10,
        },
      },
    });
  }

  static scrollSlider() {
    NpThumSwiper.scrollSwiper = new Swiper(".mpScrollSwiper", {
      direction: "vertical",
      spaceBetween: 15,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        300: {
          direction: "horizontal",
          slidesPerView: 5,
          spaceBetween: 16,
        },
        769: {
          direction: "vertical",
          slidesPerView: 5,
        },
        1201: {
          direction: "vertical",
          slidesPerView: 7,
        },
        1401: {
          direction: "vertical",
          slidesPerView: 9,
        },
      },
      on: {
        reachEnd: function () {
          enablePrevious();
        },
        reachBeginning: function () {
          enableNext();
        },
      },
    });

    var swiperButton = document.querySelector(".swiper-button");
    var isNext = true;

    if (!swiperButton) return;

    swiperButton.addEventListener("click", function () {
      if (isNext) {
        NpThumSwiper.scrollSwiper.slideNext();
      } else {
        NpThumSwiper.scrollSwiper.slidePrev();
      }
    });

    function enablePrevious() {
      isNext = false;
      swiperButton?.classList.add("prev__added");
      swiperButton?.classList.remove("next__added");
    }

    function enableNext() {
      isNext = true;
      swiperButton?.classList.add("next__added");
      swiperButton?.classList.remove("prev__added");
    }
  }

  static virtual(src, media, title) {
    if (!Array.isArray(media) || !title) return;

    let x = "";
    let y = "";
    const titleLower = title.trim().toLowerCase();
    const toHandle = (text) =>
      (text || "")
        .toString()
        .trim()
        .toLowerCase()
        .replace(/['"]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    const titleToken = titleLower.replace(/\s+/g, "-");
    const titleHandle = toHandle(titleLower);

    const getAltParts = (alt) => {
      const raw = typeof alt === "string" ? alt.trim().toLowerCase() : "";
      const [label = "", token = ""] = raw.split("#");

      return {
        raw,
        label: label.trim(),
        token: token.trim(),
        rawHandle: toHandle(raw),
        labelHandle: toHandle(label),
        tokenHandle: toHandle(token),
      };
    };

    const isVariantMatch = (alt) => {
      const parts = getAltParts(alt);
      return (
        parts.token === titleToken ||
        parts.token === titleHandle ||
        parts.tokenHandle === titleHandle ||
        parts.label === titleLower ||
        parts.labelHandle === titleHandle ||
        parts.raw === titleLower ||
        parts.rawHandle === titleHandle
      );
    };

    const isDefaultMedia = (alt) => {
      const parts = getAltParts(alt);
      return (
        parts.token.includes("default") ||
        parts.label.includes("default") ||
        parts.raw.includes("default")
      );
    };

    const isModelMedia = (media) => {
      const src = (media?.src || "").toLowerCase();
      const parts = getAltParts(media?.alt);

      return (
        src.includes("_model_") ||
        src.includes("model_") ||
        src.includes("-model-") ||
        parts.label.includes("model") ||
        parts.token.includes("model")
      );
    };

    const hasVariantMatch = media.some((m) => isVariantMatch(m.alt));
    const isCurrentImage = (mediaSrc) =>
      !!src &&
      !!mediaSrc &&
      (mediaSrc === src || mediaSrc.includes(src) || src.includes(mediaSrc));

    const variantNonModel = [];
    const variantModel = [];
    const defaultNonModel = [];
    const defaultModel = [];

    media.forEach((m, index) => {
      const modelMedia = isModelMedia(m);
      const variantMatch = isVariantMatch(m.alt);
      const defaultMatch = isDefaultMedia(m.alt);
      const fallbackMatch = isCurrentImage(m.src);
      const item = { m, index };

      if (hasVariantMatch) {
        if (variantMatch) {
          if (modelMedia) variantModel.push(item);
          else variantNonModel.push(item);
        } else if (defaultMatch) {
          if (modelMedia) defaultModel.push(item);
          else defaultNonModel.push(item);
        }
      } else if (fallbackMatch || defaultMatch) {
        if (modelMedia) defaultModel.push(item);
        else defaultNonModel.push(item);
      }
    });

    const orderedItems = [
      ...variantNonModel,
      ...variantModel,
      ...defaultNonModel,
      ...defaultModel,
    ];

    orderedItems.forEach(({ m, index }) => {
      x += `<div class="swiper-slide np-scroll-swiper" data-alt="${m.alt}" data-index="${index}">
                  <img src="${m.src}" alt="${m.alt}" class="np-scroll-image">
                </div>`;
      y += `<div class="swiper-slide np-swiper-slide" data-src="${m.src}" data-index="${index}">
                  <div class="np-ts-image-wrapper" onmouseleavee="zoomOut(event)" onmousemovee="zoom(event)" data-src="${m.src}">
                    <img src="${m.src}" alt="${m.alt}" class="np-thumb-image" style="aspect-ratio:1/1;object-fit:cover;">
                  </div>
                </div>`;
    });

    if (!orderedItems.length) return;

    document.querySelector(".mpScrollSwiper .swiper-wrapper").innerHTML = x;
    document.querySelector(".mpThumbSwiepr .swiper-wrapper").innerHTML = y;

    // Destroy old instances and reinitialize to properly reset pagination, navigation, and thumbs
    if (NpThumSwiper.thumbSwiper) NpThumSwiper.thumbSwiper.destroy(true, false);
    if (NpThumSwiper.scrollSwiper) NpThumSwiper.scrollSwiper.destroy(true, false);

    NpThumSwiper.scrollSlider();
    NpThumSwiper.thumbSlider();

    NpThumSwiper.scrollSwiper.slideTo(0, 0);
    NpThumSwiper.thumbSwiper.slideTo(0, 0);
  }

  static gotoSlide(index) {
    NpThumSwiper.thumbSwiper.slideTo(index);
  }

  static activeSlide(src) {
    document.querySelectorAll(".np-swiper-slide").forEach((slide) => {
      if (slide.dataset.src === src) {
        NpThumSwiper.gotoSlide(slide.dataset.index);
      }
    });
  }
}

customElements.define("np-media", NpThumSwiper);

class NpQuantity extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("button").forEach((btn) =>
      btn.addEventListener("click", this.clickEventHandler.bind(this))
    );
    this.input = this.querySelector("input");
  }

  clickEventHandler(e) {
    e.preventDefault();
    switch (e.target.dataset.type) {
      case "plus":
        this.qtyHandler(1);
        break;
      case "minus":
        this.qtyHandler(-1);
        break;
    }
  }

  qtyHandler(n) {
    let value = parseInt(this.input.value);
    value += n;
    if (value < 1) value = 1;

    this.input.value = value;
  }
}

customElements.define("np-quantity", NpQuantity);

class NpVariants extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    this.form.addEventListener("input", this.inputEventHandler.bind(this));
  }

  inputEventHandler() {
    this.getProductData();
    if (!this.product) return;
    this.updateOptions();
    this.updateMasterId();
    if (!this.currentVariant) return;
    this.slideTo();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  getProductData() {
    if (this.product) return;

    const productDataEl = document.querySelector(
      '[type="application/json-product"]'
    );
    if (!productDataEl) return;

    this.product = JSON.parse(productDataEl.textContent);
    this.media = this.product?.media;
    this.variants = this.product?.variants;
    this.options = new Array(this.product?.options?.length);
  }

  updateOptions() {
    if (!this.options) return;
    this.querySelectorAll("select").forEach((select) =>
      this.options.splice(parseInt(select.dataset.index) - 1, 1, select.value)
    );
    Array.from(this.querySelectorAll(".np-variant-button-wrapper")).map(
      (fieldset) =>
        this.options.splice(
          parseInt(
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked
            ).dataset.index
          ) - 1,
          1,
          Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked
          ).value
        )
    );
  }

  updateMasterId() {
    this.currentVariant = this.variants?.find(
      (variant) =>
        !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(false)
    );
  }

  slideTo() {
    if (!this.currentVariant) return;
    NpThumSwiper.virtual(
      this.currentVariant?.featured_image?.src,
      this.media,
      this.currentVariant.title
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForm = document.querySelector(".npForm");
    if (productForm) {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const nextPriceWrapper = html.querySelector(".np-price-wrapper");
        const nextVariantSelected = html.querySelector(".np-variant-selected");
        const nextFormInnerWrapper = html.querySelector(".form__inner-wrapper");
        const nextInventory = html.querySelector(".pdp__inventory");
        const nextNotifyStock = html.querySelector(".notify-stock-x");

        if (document.querySelector(".np-price-wrapper") && nextPriceWrapper) {
          document.querySelector(".np-price-wrapper").innerHTML =
            nextPriceWrapper.innerHTML;
        }
        if (document.querySelector(".np-variant-selected") && nextVariantSelected) {
          document.querySelector(".np-variant-selected").innerHTML =
            nextVariantSelected.innerHTML;
        }
        // if(document.querySelector(".npf__submit-text")) document.querySelector(".npf__submit-text").innerHTML = html.querySelector(".npf__submit-text").innerHTML
        if (document.querySelector(".form__inner-wrapper") && nextFormInnerWrapper) {
          document.querySelector(".form__inner-wrapper").innerHTML =
            nextFormInnerWrapper.innerHTML;
        }
        if (document.querySelector(".pdp__inventory") && nextInventory) {
          document.querySelector(".pdp__inventory").innerHTML =
            nextInventory.innerHTML;
        }
        if (document.querySelector(".notify-stock-x") && nextNotifyStock) {
          document.querySelector(".notify-stock-x").innerHTML =
            nextNotifyStock.innerHTML;
        }
      })
      .finally(() => {
        if (typeof notifyPopup === "function") notifyPopup();
        let npForm = document.querySelector("np-form");
        if (document.querySelector(".npf-submit"))
          document
            .querySelector(".npf-submit")
            .addEventListener("click", (e) => npForm.formSubmit(e));
      });
  }
}

customElements.define("np-variants", NpVariants);

class NPForm extends HTMLElement {
  constructor() {
    super();

    const submitButton = this.querySelector(".npf-submit");
    if (submitButton) {
      submitButton.addEventListener("click", this.formSubmit.bind(this));
    }
    this.form = this.querySelector(".npFormSubmit");
    this.miniCart = document.querySelector("mini-cart");
  }

  formSubmit(e) {
    e.preventDefault();

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData(this.form);

    if (this.miniCart) {
      formData.append(
        "sections",
        this.miniCart.getSectionsToRender().map((section) => section.id)
      );
    }
    formData.append("sections_url", window.location.pathname);
    config.body = formData;

    fetch(`${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: response.errors || response.description,
            message: response.message,
          });
          console.log(response.errors || response.description);
          this.error = true;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
          });
        this.error = false;

        if (this.miniCart) {
          this.miniCart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this.miniCart && this.miniCart.classList.contains("is-empty"))
          this.miniCart.classList.remove("is-empty");
      });
  }
}
customElements.define("np-form", NPForm);
